var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('v-chart',{attrs:{"id":"cost","options":_vm.graph}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }